import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";

@customElement("cost-summary-sticky")
export class CostSummarySticky extends LitElement {
  @property({ type: Number }) driverCost = 0;
  @property({ type: Number }) companyCost = 0;
  @property({ type: String }) driverSubtitle = "Förmånsvärde + drivmedel";
  @property({ type: String }) companySubtitle = "Exkl. moms";
  @state() isHidden = false;

  private observer: IntersectionObserver | null = null;

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.setupObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private setupObserver() {
    // Wait for the DOM to be ready
    setTimeout(() => {
      const detailsElement = document.getElementById('details');
      if (!detailsElement) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.isHidden = entry.isIntersecting;
          });
        },
        {
          threshold: 0.25,
          rootMargin: '0px'
        }
      );

      this.observer.observe(detailsElement);
    }, 100);
  }

  render() {
    return html`
      <div class="fixed bottom-0 left-0 w-full h-auto z-50 bg-neutral border-t border-neutral-shadow transition-transform duration-300 ease-in-out ${this.isHidden ? 'translate-y-full' : 'translate-y-0'}">
        <div class="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-0 py-4 md:py-6">
          <div class="grid grid-cols-12 gap-0 md:gap-10">

            <!-- Title -->
            <div class="col-span-12 md:col-span-4 hidden md:block">
              <h3 class="h6 font-bold">Totalkostnad/månad</h3>
            </div>

            <div class="col-span-12 md:col-span-8 flex flex-col md:flex-row justify-end gap-2 md:gap-8">

              <!-- Driver's Cost -->
              <div class="flex flex-row md:flex-col justify-between">
                <div>
                  <p class="preamble">Förarens kostnad</p>
                  <p class="small italic text-price md:mt-1">${this.driverSubtitle}</p>
                </div>
                <div class="preamble">
                  ${this.driverCost.toLocaleString("sv-SE")} kr
                </div>
              </div>

              <!-- Company's Cost -->
              <div class="flex flex-row md:flex-col justify-between">
                <div>
                    <p class="preamble">Företagets leasing</p>
                    <p class="small italic text-price md:mt-1">${this.companySubtitle}</p>
                </div>
                <div class="preamble">
                  ${this.companyCost.toLocaleString("sv-SE")} kr
                </div>
              </div>

              <!-- Detailed Information Link -->
              <div class="hidden md:block">
                <a href="#details" class="p underline hover:no-underline">
                  Detaljerad information
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    `;
  }
}
